/* src/app/components/payroll/corrections/nav-reset/nav-reset.component.css */
.table-style {
  width: 100%;
}
/*# sourceMappingURL=nav-reset.component-KRU6JJNP.css.map */
